import styled from 'styled-components';

export const Wrapper = styled.div`
	display: block;
	width: 100%;
	padding: 30px;
	text-align: center;
	font-size: 30px;
`;
